import React from 'react';
import {makeStyles} from '@material-ui/styles';
import Header from '../Header/Header';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import StepperForm from '../StepperForm/StepperForm';
import theme from '../../theme';

const useStyles = makeStyles({
    root : {
        margin: theme.spacing(0, 'auto'),
        fontSize: '1rem',
        maxWidth: '90%'
    }
})

const Home : React.FC = () => {

    const classes = useStyles()

    return (
        <div className={classes.root}>

            <Container maxWidth="md">
                <Header />
                <Box my={4}>
                    <StepperForm />
                </Box>
            </Container>

        </div>
    )
}

export default Home;